import { CACHE_CONFIG } from '../constants/gridConfig';

// Optimized cache for dynamic props with size limit and cleanup
export const propsCache = new Map();

/**
 * Clean up cache when it exceeds maximum size
 */
export const cleanupCache = () => {
  if (propsCache.size > CACHE_CONFIG.MAX_CACHE_SIZE) {
    const keysToDelete = Array.from(propsCache.keys()).slice(0, propsCache.size - CACHE_CONFIG.MAX_CACHE_SIZE);
    keysToDelete.forEach(key => propsCache.delete(key));
  }
};

/**
 * Generate cache key for component props
 * @param {string} displayName - Component display name
 * @param {Array} markersData - Markers data for floor plan
 * @param {Object} planData - Plan data
 * @param {Object} legacySignage - Legacy signage data
 * @returns {string} Cache key
 */
export const generateCacheKey = (displayName, markersData = [], planData = null, legacySignage = null) => {
  switch (displayName) {
    case 'Floor Plan ':
      // For floor plan, include markers timestamp in cache key
      const markersTimestamp = markersData.length > 0 ? markersData[0]?.timestamp : 'empty';
      return `${displayName}-${planData?.rawUrl}-${markersTimestamp}`;
    case 'Date and Time':
    case 'DateAndTime':
    case 'DateLegend':
      // Time components now handled by TimeIsolatedWrapper - no caching needed
      return `${displayName}-isolated`;
    case 'Building Info':
      return `${displayName}-${legacySignage?.address}`;
    default:
      return `${displayName}-static`;
  }
};

/**
 * Get cached props or compute new ones
 * @param {string} cacheKey - Cache key
 * @param {Function} computeProps - Function to compute props if not cached
 * @returns {Object} Props object
 */
export const getCachedProps = (cacheKey, computeProps) => {
  if (propsCache.has(cacheKey)) {
    return propsCache.get(cacheKey);
  }
  
  // Cleanup cache if it gets too large
  cleanupCache();
  
  const props = computeProps();
  propsCache.set(cacheKey, props);
  return props;
};
